enum CountdownState {
  Initialize,
  Countdown,
  Complete
}

export default CountdownState;
